import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Classe } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useClasse, useDeleteClasse, useUpdateClasse } from '../../hooks/classi'
import ClasseForm from '../../components/ClasseForm'

export default function ClasseEdit() {
  const { id } = useParams()
  const { data: classe } = useClasse(+id!)
  const deleteClasse = useDeleteClasse()
  const updateClasse = useUpdateClasse()
  const [modalRm, modalRmActions] = useModalTrigger<Classe>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/classi">Classi</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {classe!.nome}
            </li>
          </ol>
        </nav>
        <div className="d-flex align-items-center">
          <button
            className="btn btn-danger"
            onClick={() => modalRmActions.open(classe)}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </div>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <ClasseForm
          classe={classe}
          save={(classeX) => 
            updateClasse.mutateAsync(classeX).then(() =>
              toast.success('Classe salvata con successo!', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare la classe {modalRm.value.nome} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteClasse.isLoading}
            onClick={async () => {
              await deleteClasse.mutateAsync(modalRm.value!.id)
              navigate('/classi')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
